<template>
  <div class="layout">
    <div
      class="list-group-item"
      v-for="(item, index) in componentsData"
      :key="index"
    >
      <component
        :is="componentMap[terminal - 1].get(item.type)"
        :componentContent="item.componentContent"
        :terminal="terminal"
        :typeId="typeId"
        :shopId="shopId"
      ></component>
    </div>
    <loading-toast ref="loadingToast"></loading-toast>
  </div>
</template>

<script>
import componentMap from "./componentMap";
import api from "./config/api";
import { sendReqMixin } from "./config/mixin";
import Cookies from "js-cookie";
import LoadingToast from "./components/toast";
import store from "./config/mixin/store";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "canvasPage",
  components: { LoadingToast },
  mixins: [sendReqMixin],
  data() {
    return {
      // terminal: 4, // 画布设备 1 小程序，2 H5，3 App 4 电脑
      // typeId: 3, // 画布类型 1 平台画布，2 自定义页面，3 商家店铺装修
      // shopId: 0, // 店铺id
      componentsData: [],
      activeComponent: -1,
      componentMap: componentMap,
    };
  },
  props: {
    terminal: {
      type: Number,
      default: 4,
    },
    typeId: {
      type: Number,
      default: 1,
    },
    shopId: {
      type: Number,
      default: 0,
    },
    canvasId: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    // this.shopId = Cookies.get('cereShopId')
    this.canvasGet();
  },
  methods: {
    ...mapMutations({
      setClassify: "SET_CLASSIFY", // 存储分类信息
      set_component : 'SET_componentContent'
    }),
    // 读取画布
    canvasGet() {
      var _this = this;
      this.$refs.loadingToast.setCanvasLoading(true);
      var apiUrl =
        api.getCanvas + "?terminal=" + this.terminal + "&type=" + this.typeId;
      if (this.shopId) {
        apiUrl += "&shopId=" + this.shopId;
      }
      if (this.canvasId) {
        apiUrl += "&canvasId=" + this.canvasId;
      }
      let params = {
        url: apiUrl,
        method: "GET",
      };
      this.sendReq(params, (res) => {
        this.$refs.loadingToast.setCanvasLoading(false);
        if (JSON.stringify(res.data) !== "{}") {
          // _this.canvasId = res.data.canvasId
          var componentsData = JSON.parse(res.data.json);
          // if(componentsData[0]){//临时处理,运营说商品太少,这里把商品列表全部屏蔽 暂时只保留一个全部商品的产品列表
          //   componentsData = [componentsData[0],componentsData[1]]
          // }
          console.log(componentsData);
          for (let i = 0; i < componentsData.length; i++) {
            // 商品列表
            if (componentsData[i].type === "productList") {
              this.$refs.loadingToast.setCanvasLoading(true);
              store.commit("loadNumAdd");
              if (
                componentsData[i].componentContent.productData.sourceType ===
                "1"
              ) {
                _this.sendReq(
                  {
                    url: `${api.getProducts}?page=1&pageSize=99&ids=${componentsData[i].componentContent.productData.productIdList}`,
                    method: "GET",
                  },
                  (proRes) => {
                    store.commit("loadNumReduce");
                    componentsData[i].componentContent.productData.imgTextData =
                      proRes.data.list;
                  }
                );
              } else if (
                componentsData[i].componentContent.productData.sourceType ===
                "2"
              ) {
                if (componentsData[i].componentContent.productData.categoryId == 2250) {
                  _this.sendReq(
                  {
                    //临时处理,运营说商品太少,这里把商品列表全部屏蔽 暂时只保留一个全部商品的产品列表
                    url: `${api.getServProducts}?page=1&pageSize=99&classifyId=${componentsData[i].componentContent.productData.categoryId}`,
                    // url: `${api.getProducts}?category=1&page=1&pageSize=99`,
                    method: "GET",
                  },
                  (proRes) => {
                    store.commit("loadNumReduce");
                    componentsData[i].componentContent.productData.imgTextData =
                      proRes.data.list;
                  }
                );
                } else {
                  _this.sendReq(
                  {
                    //临时处理,运营说商品太少,这里把商品列表全部屏蔽 暂时只保留一个全部商品的产品列表
                    url: `${api.getProducts}?page=1&pageSize=99&classifyId=${componentsData[i].componentContent.productData.categoryId}`,
                    // url: `${api.getProducts}?category=1&page=1&pageSize=99`,
                    method: "GET",
                  },
                  (proRes) => {
                    store.commit("loadNumReduce");
                    componentsData[i].componentContent.productData.imgTextData =
                      proRes.data.list;
                  }
                );
                }
                
              }
            } else if (
              componentsData[i].type === "coupon" ||
              componentsData[i].type === "groupList" ||
              componentsData[i].type === "spikeList" ||
              componentsData[i].type === "discountList"
            ) {
              this.$refs.loadingToast.setCanvasLoading(true);
              store.commit("loadNumAdd");
            } else if (
              componentsData[i].type === "shopHeader" &&
              this.terminal === 4
            ) {
              
              if (
                componentsData[i].componentContent.category &&
                componentsData[i].componentContent.category.length !== 0
              ) {
                var categoryArr = componentsData[i].componentContent.category;
                _this.sendReq(
                  {
                    url: `${api.getClassify}`,
                    method: "GET",
                  },
                  (proRes) => {
                    
                    // _this.setClassify(proRes.data);
                    // componentsData[i].componentContent.category = proRes.data.filter((item) => {
                    //   for (let i = 0; i < categoryArr.length; i++) {
                    //     if (categoryArr[i].id === item.id) {
                    //       return true
                    //     }
                    //   }
                    // })
                    componentsData[i].componentContent.category = proRes.data;
                    _this.set_component(componentsData);
                    _this.setClassify(proRes.data);
                    // for (let i in componentsData) {
                    //   if (componentsData[i].type === "shopHeader") {
                    //     _this.componentContent =
                    //       componentsData[i].componentContent;
                    //     break;
                    //   }
                    // }

                    console.log(componentsData[i].componentContent.category);
                  }
                );
              }
            }
          }
          _this.componentsData = componentsData;
          console.log(_this.componentsData);
        } else {
          // _this.canvasId = ''
        }
        // console.log(JSON.parse(res.data.json))
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.hom-layout {
  background-color: #f5f5f5;
}
.list-group-item {
  background-color: rgb(247, 245, 246);
}
</style>

<style lang="scss">
.warp {
  width: 690px;
  margin: 0 auto;
  max-width: 100%;
  &.terminal4 {
    width: 1250px;
    max-width: 96%;
  }
}
.flex-box {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/canvasShow/canvasShowPage.vue